import $ from 'jquery';
import L from 'leaflet';
import 'leaflet.fullscreen';

const connector = require('./connector.js');

let initialCordinates  = ['37.0902', '-95.7129'];
let initialZoomLevel   = 4;
let isMapInitialized   = false;
let loadingBtnInterval = null;
var map = null;
var markers = null;

function init(ffl_checkout_by_ttg_initial_map_latitude, ffl_checkout_by_ttg_initial_map_longitude, ffl_checkout_by_ttg_initial_map_zoom) {

    initialCordinates = [ffl_checkout_by_ttg_initial_map_latitude, ffl_checkout_by_ttg_initial_map_longitude];
    initialZoomLevel  = ffl_checkout_by_ttg_initial_map_zoom;

    markers = [];
    map = L.map('ffl-checkout-by-ttg-leaflet-map', {
        fullscreenControl: true,
        fullscreenControlOptions: {
            title:          'Show me the fullscreen!',
            titleCancel:    'Exit fullscreen mode'
        }
    })

    map.setView(initialCordinates, initialZoomLevel); 
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', { attribution: '<a href="https://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap licensing</a> | FFL Checkout developed by <a href="https://texastechnologygroup.com/product/ffl-checkout/" target="_blank">Texas Technology Group</a>' }).addTo(map);

    $(window).keydown(function(event) {

        if (event.keyCode == 13) {

            if (event.target.id == "ffl-checkout-by-ttg-zip-code-input") {
                
                if (isValidUSZip($('#ffl-checkout-by-ttg-zip-code-input').val())) {
                    sendApiRequest();
                } else {
                    alert('The zip code provided is invalid');
                }
            }

            event.preventDefault();
            event.stopPropagation();
            return false;
        }
    });

    $('#ffl-checkout-by-ttg-search-button').click(function() {

        if (isValidUSZip($('#ffl-checkout-by-ttg-zip-code-input').val())) {
            return sendApiRequest();
        }

        alert('The zip code provided is invalid');
    });

    let debounceTimeout;

    $('.ffl-checkout-by-ttg-dealer-list-search').on('input', function() {

        clearTimeout(debounceTimeout);

        let $search = $(this);

        debounceTimeout = setTimeout(function() {

            let searchText = $search.val().toLowerCase(); // Get input value and convert to lowercase
            
            $('#ffl-checkout-by-ttg-dealer-list .dealer').each(function() {

                let dealerName = $(this).data('name').toLowerCase();
                let dealerFFL = $(this).data('ffl');

                if (dealerName.includes(searchText) || dealerFFL.toLowerCase().includes(searchText)) {

                    markers.forEach(function(marker) {
                        if (marker.ffl == dealerFFL) {
                            $(marker.marker._icon).show();
                            $(marker.marker._shadow).show();
                        }
                    });

                    $(this).show();
                } else {

                    markers.forEach(function(marker) {
                        if (marker.ffl == dealerFFL) {
                            marker.marker.closePopup();
                            $(marker.marker._icon).hide();
                            $(marker.marker._shadow).hide();
                        }
                    });
                    
                    $(this).hide(); 
                }

                if ($('#ffl-checkout-by-ttg-dealer-list .dealer:visible').length == 0 && $(".ffl-checkout-by-ttg-dealers-not-found").length == 0) {
                    $('#ffl-checkout-by-ttg-dealer-list').append('<p class="ffl-checkout-by-ttg-dealers-not-found">No FFL dealers found within the specified radius.</p>');
                } else if ($('.dealer:visible').length > 0) {
                    $(".ffl-checkout-by-ttg-dealers-not-found").remove();
                }
            });
        }, 1000);
    });

    function sendApiRequest() {

        setLoading();
        $('#ffl-checkout-by-ttg-dealer-list').slideUp();
        hideSearchInput();

        var zipCode     = $('#ffl-checkout-by-ttg-zip-code-input').val();
        var radiusMiles = $('#ffl-checkout-by-ttg-radius-miles-input').val();

        if (!zipCode) {
            alert('Please enter a ZIP code.');
            return;
        }

        var action = 'FFLCheckoutByTTG_FindFFLByZipAction';
        var data = {
            zipCode: zipCode,
            radiusMiles: parseInt(radiusMiles),
            onlyOnFile: FFLCheckoutByTTG_FindFFLByZipAction.onlyOnFile,
        };

        $.get(FFLCheckoutByTTG_FFLCheckoutApi.url + "/api/ffl/search/zipcode", data, function(response) {

            removeLoading();

            if (response.success) {
                processData(response.data);
                return;
            } 

            emptyDealers(true);
        });
    }

    function setLoading() {
       loadingBtnInterval = animateLoading('#ffl-checkout-by-ttg-search-button');
    }

    function removeLoading() {

        clearInterval(loadingBtnInterval);
        $('#ffl-checkout-by-ttg-search-button').text('Find an FFL');
    }

    function showSearchInput() {

        $('.ffl-checkout-by-ttg-dealer-list-search').val("");
        $('.ffl-checkout-by-ttg-dealer-list-search').show();
    }

    function hideSearchInput() {

        $('.ffl-checkout-by-ttg-dealer-list-search').val("");
        $('.ffl-checkout-by-ttg-dealer-list-search').hide();
    }

    function isValidUSZip(zip) {

        // Regular expression for valid US ZIP codes (5 digits or 5 digits followed by a hyphen and 4 more digits)
        var zipRegExp = /^\d{5}(?:-\d{4})?$/;
        return zipRegExp.test(zip);
    }

    function emptyDealers(isError = false) {
        
        hideSearchInput();
        $('#ffl-checkout-by-ttg-dealer-list').html('<p class="ffl-checkout-by-ttg-dealers-not-found">No FFL dealers found within the specified radius.</p>');
        $('#ffl-checkout-by-ttg-dealer-list').slideDown();

        if (isError) {
            $('#ffl-checkout-by-ttg-dealer-list').html('<p class="ffl-checkout-by-ttg-dealers-not-found">There was an error trying to fetch FFL dealers in your area, please contact our support team for further assistance.</p>');
        }

        markers.forEach(function(marker) {
            marker.marker.closePopup();
            $(marker.marker._icon).hide();
            $(marker.marker._shadow).hide();
        });

        return map.flyTo(initialCordinates, initialZoomLevel, {
            animate: true,
            duration: 1.5,
            easeLinearity: 0.25
        });
    }

    function processData(data) {

        $('#ffl-checkout-by-ttg-dealer-list').empty();
        markers.forEach(function(marker) {
            map.removeLayer(marker.marker);
        });

        markers = []; 

        if (data.length === 0) {
            emptyDealers();
        }

        showSearchInput();

        let bounds = [];

        data.forEach(function(ffl, index) {
            populateFFLEntity(ffl, bounds);
        });

        if (bounds.length > 0) {
            map.fitBounds(bounds);
        }

        connector.changeShippingValues("", "", "", "", "");
        connector.hideSOTUploadOptions();

        $('#ffl-checkout-by-ttg-dealer-list').slideDown();
        $('#ffl-checkout-by-ttg-dealer-list').scrollTop(0);
    }

    function populateFFLEntity(ffl, bounds) {


        let fflOnFileBadge = ffl.ffl_on_file ? `<span class="ffl-checkout-by-ttg-on-file-badge ffl-checkout-by-ttg-on-file-badge-ffl">FFL on file</span>` : ``;
        let sotOnFileBadge = (connector.isSOTUploadEnabled() && ffl.sot_on_file) ? `<span class="ffl-checkout-by-ttg-on-file-badge ffl-checkout-by-ttg-on-file-badge-sot">SOT on file</span>` : ``;

        let knowSOTBadge = (connector.isSOTUploadEnabled() && !ffl.sot_on_file && ffl.is_known_sot) ? `<span class="ffl-checkout-by-ttg-on-file-badge ffl-checkout-by-ttg-on-file-badge-sot-light">Known SOT, not on file</span>` : ``;


        let dealerDiv = $(`
        <div style="display:flex; flex;flex-direction: column;" class="dealer" data-name="` + ffl.prefered_name + `" data-ffl="` + ffl.license_number + `" data-lat="` + ffl.premises_latitude + `" data-lon="` + ffl.premises_longitude + `">
            <div style="display:flex; justify-content:start; padding: 5px 0px;">
                <div style="display:flex; flex-direction:column; flex: 1;">
                    <div style="display:flex; justify-content:space-between;">
                        <div>
                            <div class="ffl-checkout-by-ttg-margin-bottom-10px">
                                <strong class="ffl-checkout-by-ttg-dealer-name">` + ffl.prefered_name + `</strong> <br>
                                ${ffl.rating || ffl.reviews ? `

                                    <div style="display: flex;">
                                        <svg width="15" height="15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.38694 14.4778C3.02507 14.6634 2.61444 14.3381 2.68757 13.9228L3.46569 9.48843L0.162878 6.34218C-0.145559 6.04781 0.0147532 5.50968 0.428191 5.45156L5.02007 4.79906L7.06757 0.742496C7.25225 0.376871 7.75194 0.376871 7.93663 0.742496L9.98413 4.79906L14.576 5.45156C14.9894 5.50968 15.1498 6.04781 14.8404 6.34218L11.5385 9.48843L12.3166 13.9228C12.3898 14.3381 11.9791 14.6634 11.6173 14.4778L7.50069 12.3628L3.38694 14.4778Z" fill="#ffbf13"></path></svg>
                                        ${ffl.rating ? `<b style="margin-left:3px;">` + ffl.rating + `</b>` : ``} ${ffl.reviews ? `<span style="margin-left:3px;">(` + ffl.reviews + ` reviews)</span>` : ``}
                                    </div>
                                    ` : `
                                    <div style="display: flex;">
                                        <svg width="15" height="15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.38694 14.4778C3.02507 14.6634 2.61444 14.3381 2.68757 13.9228L3.46569 9.48843L0.162878 6.34218C-0.145559 6.04781 0.0147532 5.50968 0.428191 5.45156L5.02007 4.79906L7.06757 0.742496C7.25225 0.376871 7.75194 0.376871 7.93663 0.742496L9.98413 4.79906L14.576 5.45156C14.9894 5.50968 15.1498 6.04781 14.8404 6.34218L11.5385 9.48843L12.3166 13.9228C12.3898 14.3381 11.9791 14.6634 11.6173 14.4778L7.50069 12.3628L3.38694 14.4778Z" fill="#ffbf13"></path></svg>
                                        <span style="margin-left:3px;">No ratings</span>
                                    </div>`
                                }

                            </div>
                            <strong>Address: </strong>` + ffl.premises_address + `, ` + ffl.premises_city + `, ` + ffl.premises_state + ` ` + ffl.premises_zip_code + `<br>
                            <strong>FFL: </strong>` + ffl.formatted_license_number + `<br>
                            <strong>Phone: </strong>` + ffl.phone_number + `
                        </div>
                        <div style="display:flex;flex-direction: column; min-width: 160px;">
                            <div style="display:flex;flex-direction: column; text-align: end;">

                                ${ffl.primary_business_type ? `<span>
                                    <svg style="height: 12px;width:12px;margin-right:3px"xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" viewBox="0 0 256 256" enable-background="new 0 0 256 256" xml:space="preserve"> <g><g><g><path fill="#fff" d="M33,10.8c-8.2,1.8-16,7.9-19.8,15.4C10,32.9,10,32.5,10,69.1c0,30.9,0,32.7,0.9,36.1c1.8,6.9,5.3,12.4,10.7,16.6c9.2,7.1,20.6,8.2,31.2,3c7.5-3.7,13.8-11.8,15.3-19.7c0.3-1.6,0.6-2.9,0.8-2.9c0.1,0,0.5,1.3,0.8,2.9c0.9,4.8,3.9,10.2,7.9,14.2c11.6,11.6,30,11.6,41.6,0c4-4.1,7-9.4,7.9-14.2c0.3-1.6,0.6-2.9,0.8-2.9c0.1,0,0.5,1.3,0.8,2.9c0.9,4.8,3.9,10.2,7.9,14.2c11.6,11.6,30,11.6,41.6,0c4-4.1,7-9.4,7.9-14.2c0.3-1.6,0.6-2.9,0.8-2.9c0.1,0,0.5,1.3,0.8,2.9c0.9,4.8,3.9,10.2,7.9,14.2c11.8,11.7,30.2,11.5,42-0.6c3.4-3.5,6.6-9.5,7.6-14.4c1-4.8,1-66.2,0-71c-2.3-11-11.6-20.3-22.6-22.6C218,9.8,37.6,9.8,33,10.8z"/><path fill="#fff" d="M66.7,133.4c-5.5,4.4-12.6,7.5-20,8.8c-5.3,1-12.9,0.6-17.7-0.7c-1.8-0.6-3.5-1-3.8-1c-0.3,0-0.5,12.6-0.5,38v37.9l-2.1,0.3c-4.7,0.6-9.1,4-11.3,8.4c-1.6,3.3-1.6,9.1,0,12.4c1.4,2.9,4.2,5.7,7.1,7.1l2.3,1.2l38.8,0.1l38.8,0.1v-34.7c0-33.6,0-34.7,0.9-36.2c1.8-3,1.1-2.9,28.6-2.9s26.8-0.1,28.6,2.9c0.9,1.4,0.9,2.6,0.9,36.2V246l38.8-0.1l38.8-0.1l2.3-1.2c3-1.4,5.7-4.2,7.1-7.1c1.6-3.3,1.6-9.1,0-12.4c-2.2-4.4-6.6-7.7-11.3-8.4l-2.1-0.3v-38.1v-38.1l-3.8,1.1c-12.2,3.5-26.5,0.7-37.6-7.5l-2.9-2.1l-3.1,2.3c-15.6,11.7-36.9,11.6-53-0.2l-2.9-2.1l-2.8,2.1c-15.9,11.9-37,12-53.3,0c-1.6-1.2-2.9-2.1-3-2.1C68.8,131.7,67.8,132.4,66.7,133.4z"/></g></g></g> </svg>
                                    ` + ffl.primary_business_type + `
                                </span>` : ``}
                                <span>
                                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#fe5757" height="12px" width="12px" version="1.1" id="Capa_1" viewBox="0 0 297 297" xml:space="preserve"> <path d="M148.5,0C85.646,0,34.511,51.136,34.511,113.989c0,25.11,8.008,48.926,23.157,68.873  c13.604,17.914,32.512,31.588,53.658,38.904l27.464,68.659c1.589,3.971,5.434,6.574,9.71,6.574c4.276,0,8.121-2.603,9.71-6.574  l27.464-68.659c21.146-7.316,40.054-20.99,53.658-38.904c15.149-19.947,23.157-43.763,23.157-68.873  C262.489,51.136,211.354,0,148.5,0z M148.5,72.682c22.777,0,41.308,18.53,41.308,41.308c0,22.777-18.53,41.309-41.308,41.309  c-22.777,0-41.308-18.531-41.308-41.309C107.192,91.212,125.723,72.682,148.5,72.682z"/> </svg>
                                    <b>` + ffl.distance + `</b> miles from center
                                </span>
                            </div>

                            
                            <div style="margin-top:10px;">
                                <div class="ffl-checkout-by-ttg-social-buttons">
                                    ${ffl.website ?
                                        `<a href="${ffl.website}" class="ffl-checkout-by-ttg-social-button ffl-checkout-by-ttg-website" target="_blank">
                                            <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 54 49" class="no-shrink website_icon"><defs><style> .cls-1 { fill:rgba(255, 255, 255, 0); } .cls-1, .cls-2 { stroke-width: 0px; } .cls-2 { fill: #fff; }</style></defs><rect class="cls-1" x="2.5" y="0" width="34" height="40"></rect><g><path class="cls-2" d="M13.1,17.5c.1,0,.3.1.4.1.3,0,.5-.1.7-.4,1.3-2.2,3.2-4.1,5.4-5.4,1.3-.7,2.7-1.3,4.1-1.6.6-1,1-1.6,1.1-1.7,0,0,.1-.1.2-.2-2.2.3-4.3,1-6.2,2-2.5,1.4-4.6,3.5-6,5.9-.2.4,0,.9.3,1.1Z"></path><path class="cls-2" d="M26.1,9.6s-.1.1-.3.4c.4,0,.8,0,1.2,0h0c.4,0,.8,0,1.2,0-.2-.2-.3-.4-.3-.4-.3-.4-.2-.9.2-1.1,0,0,.1,0,.2-.1-.4,0-.9,0-1.3,0h0c-.4,0-.9,0-1.3,0,0,0,.2,0,.2.1.4.3.4.8.2,1.1Z"></path><path class="cls-2" d="M23.7,38.7c-1.4-.3-2.8-.9-4.1-1.6-2.2-1.3-4.1-3.1-5.4-5.4-.2-.4-.7-.5-1.1-.3-.4.2-.5.7-.3,1.1,1.4,2.5,3.5,4.5,6,5.9,1.9,1.1,4,1.8,6.2,2,0,0-.2-.1-.2-.2,0,0-.5-.6-1.1-1.7Z"></path><path class="cls-2" d="M30.3,10.3c1.4.3,2.8.9,4.1,1.6,2.2,1.3,4.1,3.1,5.4,5.4.2.4.7.5,1.1.3.4-.2.5-.7.3-1.1-1.4-2.5-3.5-4.5-6-5.9-1.9-1.1-4-1.8-6.2-2,0,0,.2.1.2.2,0,0,.5.6,1.1,1.7Z"></path><path class="cls-2" d="M40.9,31.5c-.4-.2-.9,0-1.1.3-1.3,2.2-3.2,4.1-5.4,5.4-1.3.7-2.7,1.3-4.1,1.6-.6,1-1,1.6-1.1,1.7,0,0-.2.1-.2.2,2.2-.3,4.3-1,6.2-2,2.5-1.4,4.6-3.5,6-5.9.2-.4,0-.9-.3-1.1Z"></path><path class="cls-2" d="M27.9,39.4s.1-.1.3-.4c-.4,0-.8,0-1.2,0,0,0,0,0,0,0-.4,0-.8,0-1.2,0,.2.2.3.4.3.4.3.4.2.9-.2,1.1,0,0-.1,0-.2.1.4,0,.8,0,1.3,0h0c.4,0,.8,0,1.3,0,0,0-.1,0-.2-.1-.4-.3-.4-.8-.2-1.1Z"></path><path class="cls-2" d="M21.1,16.5c-.1.4.1.9.5,1,0,0,.1,0,.2,0,.3,0,.7-.2.8-.6,1-3.6,2.6-6.1,3.2-7-.7,0-1.4.2-2.1.3-.8,1.4-1.8,3.5-2.6,6.3Z"></path><path class="cls-2" d="M44.3,20.6c-.4-.1-.9.1-1,.5l-1.6,5.2-1.6-5.2c-.1-.3-.4-.6-.8-.6s-.7.2-.8.6l-1.6,5.2-1.6-5.2c-.1-.4-.6-.7-1-.5-.4.1-.7.6-.5,1l2.3,7.7c.1.3.4.6.8.6s.7-.2.8-.6l1.6-5.2,1.6,5.2c.1.3.4.6.8.6s.7-.2.8-.6l2.3-7.7c.1-.4-.1-.9-.5-1Z"></path><path class="cls-2" d="M31.3,17c.1.4.4.6.8.6s.1,0,.2,0c.4-.1.7-.6.5-1-.8-2.8-1.9-4.9-2.6-6.3-.7-.2-1.4-.3-2.1-.3.6.9,2.1,3.4,3.2,7Z"></path><path class="cls-2" d="M31.9,20.6c-.4-.1-.9.1-1,.5l-1.6,5.2-1.6-5.2c-.1-.3-.4-.6-.8-.6s-.7.2-.8.6l-1.6,5.2-1.6-5.2c-.1-.4-.6-.7-1-.5-.4.1-.7.6-.5,1l2.3,7.7c.1.3.4.6.8.6s.7-.2.8-.6l1.6-5.2,1.6,5.2c.1.3.4.6.8.6s.7-.2.8-.6l2.3-7.7c.1-.4-.1-.9-.5-1Z"></path><path class="cls-2" d="M32.9,32.5c.1-.4-.1-.9-.5-1-.4-.1-.9.1-1,.5-1,3.6-2.6,6.1-3.2,7,.7,0,1.4-.2,2.1-.3.8-1.4,1.8-3.5,2.6-6.3Z"></path><path class="cls-2" d="M22.6,32c-.1-.4-.6-.7-1-.5-.4.1-.7.6-.5,1,.8,2.8,1.9,4.9,2.6,6.3.7.2,1.4.3,2.1.3-.6-.9-2.1-3.4-3.2-7Z"></path><path class="cls-2" d="M14.6,24.2l1.6,5.2c.1.3.4.6.8.6s.7-.2.8-.6l2.3-7.7c.1-.4-.1-.9-.5-1-.4-.1-.9.1-1,.5l-1.6,5.2-1.6-5.2c-.1-.3-.4-.6-.8-.6s-.7.2-.8.6l-1.6,5.2-1.6-5.2c-.1-.4-.6-.7-1-.5-.4.1-.7.6-.5,1l2.3,7.7c.1.3.4.6.8.6s.7-.2.8-.6l1.6-5.2Z"></path><path class="cls-2" d="M30.3,38.7c-.7.2-1.4.3-2.1.3-.2.2-.3.4-.3.4-.3.4-.2.9.2,1.1,0,0,.1,0,.2.1.2,0,.5,0,.7,0,0,0,.2-.1.2-.2,0,0,.5-.6,1.1-1.7Z"></path><path class="cls-2" d="M27.9,9.6s.1.1.3.4c.7,0,1.4.2,2.1.3-.6-1-1-1.6-1.1-1.7,0,0-.1-.1-.2-.2-.2,0-.5,0-.7,0,0,0-.2,0-.2.1-.4.3-.4.8-.2,1.1Z"></path><path class="cls-2" d="M26.1,39.4s-.1-.1-.3-.4c-.7,0-1.4-.2-2.1-.3.6,1,1,1.6,1.1,1.7,0,0,.2.1.2.2.2,0,.5,0,.7,0,0,0,.1,0,.2-.1.4-.3.4-.8.2-1.1Z"></path><path class="cls-2" d="M23.7,10.3c.7-.2,1.4-.3,2.1-.3.2-.2.3-.4.3-.4.3-.4.2-.9-.2-1.1,0,0-.1,0-.2-.1-.2,0-.5,0-.7,0,0,0-.2.1-.2.2,0,0-.5.6-1.1,1.7Z"></path></g></svg>
                                        </a>` : 
                                        ``
                                    }

                                    ${ffl.facebook_link ? `<a href="${ffl.facebook_link}" class="ffl-checkout-by-ttg-social-button ffl-checkout-by-ttg-facebook" target="_blank">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="none" class="no-shrink"><mask id="mask0_332_909" maskUnits="userSpaceOnUse" x="0" y="0" width="35" height="35" style="mask-type: luminance;"><path d="M31.0352 0H3.96484C1.77512 0 0 1.77512 0 3.96484V31.0352C0 33.2249 1.77512 35 3.96484 35H31.0352C33.2249 35 35 33.2249 35 31.0352V3.96484C35 1.77512 33.2249 0 31.0352 0Z" fill="white"></path></mask><g mask="url(#mask0_332_909)"><path d="M31.0352 0H3.96484C1.77512 0 0 1.77512 0 3.96484V31.0352C0 33.2249 1.77512 35 3.96484 35H31.0352C33.2249 35 35 33.2249 35 31.0352V3.96484C35 1.77512 33.2249 0 31.0352 0Z" fill="#1877F2"></path><path d="M35 17.5C35 7.83506 27.1648 0 17.5 0C7.83506 0 0 7.83493 0 17.5C0 26.2347 6.39953 33.4746 14.7656 34.7874V22.5586H10.3223V17.5H14.7656V13.6445C14.7656 9.25858 17.3783 6.83592 21.3755 6.83592C23.2902 6.83592 25.2929 7.17773 25.2929 7.17773V11.4844H23.0863C20.9121 11.4844 20.2343 12.8334 20.2343 14.2174V17.5H25.0879L24.312 22.5586H20.2343V34.7874C28.6005 33.4746 35 26.2348 35 17.5Z" fill="#1877F2"></path><path d="M24.3147 22.5578L25.0907 17.4992H20.2372V14.2166C20.2372 12.8325 20.9152 11.4836 23.0891 11.4836H25.2958V7.177C25.2958 7.177 23.2931 6.83521 21.3784 6.83521C17.3812 6.83521 14.7685 9.25785 14.7685 13.6438V17.4992H10.3251V22.5578H14.7685V34.7867C15.673 34.9284 16.5871 34.9995 17.5028 34.9992C18.4184 34.9995 19.3327 34.9284 20.2372 34.7867V22.5578H24.3147Z" fill="white"></path></g></svg>
                                    </a>` : ``}

                                    ${ffl.yelp_link ? `<a href="${ffl.yelp_link}" class="ffl-checkout-by-ttg-social-button ffl-checkout-by-ttg-yelp" target="_blank">
                                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"> <style type="text/css"> .st0yelp{fill-rule:evenodd;clip-rule:evenodd; fill:#fff} </style> <g> <path class="st0yelp" d="M205.85,285.01L63.4,233.07c-15.47,41.55-17.02,85.22,0,131.73l144.35-50.1   C217.57,303.32,213.35,293.94,205.85,285.01z M226.47,353.67l-95.59,107.62c29.12,40.67,72.13,53.86,123.73,50.1l-4.71-148.46   C246.8,352.1,236.97,352.32,226.47,353.67z M308.02,335.11c-10.11,2.26-15.47,8.27-13.11,20.41l79.4,133.03   c35.3-16.02,70.56-53.45,86.49-108.9L308.02,335.11z M460.33,256.13c-10.37-59.41-46.92-99.78-79.58-119.96l-92.41,122.86   c-0.85,13.22,5.95,18.86,15,22.26L460.33,256.13z M235.73,242.85L93.35,51.75C134,15.73,180.51-9.58,258.1,3.49v231.96   C258.1,246.56,243.85,249.05,235.73,242.85z"/> </g> </svg>
                                    </a>` : ``}

                                    <a href="https://openffls.com/ffl/${ffl.license_number}" class="ffl-checkout-by-ttg-social-button ffl-checkout-by-ttg-website" target="_blank">
                                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 500 500" style="enable-background:new 0 0 500 500;" xml:space="preserve"> <style type="text/css"> .opback{fill:#ffffff00;} .opletter{fill:#fff;} </style> <circle class="opback" cx="250" cy="250" r="250"/> <path class="opletter" d="M177.1,316.4c-14.9,0-27.1-3.5-36.6-10.5c-9.4-7.1-14.1-17.3-14.1-30.4c0-2.8,0.3-6.1,0.9-10.1  c1.6-9,3.9-19.8,6.9-32.5c8.5-34.4,30.5-51.6,65.9-51.6c9.6,0,18.3,1.6,25.9,4.9c7.6,3.1,13.6,7.9,18,14.3  c4.4,6.3,6.6,13.8,6.6,22.5c0,2.6-0.3,5.9-0.9,9.9c-1.9,11.1-4.1,22-6.8,32.5c-4.4,17.1-11.9,30-22.7,38.5  C209.5,312.3,195.1,316.4,177.1,316.4z M179.8,289.4c7,0,12.9-2.1,17.8-6.2c5-4.1,8.6-10.4,10.7-19c2.9-11.8,5.1-22,6.6-30.8  c0.5-2.6,0.8-5.3,0.8-8.1c0-11.4-5.9-17.1-17.8-17.1c-7,0-13,2.1-18,6.2c-4.9,4.1-8.4,10.4-10.5,19c-2.3,8.4-4.5,18.6-6.8,30.8  c-0.5,2.5-0.8,5.1-0.8,7.9C161.7,283.7,167.8,289.4,179.8,289.4z"/> <path class="opletter" d="M259.3,314.6c-1.4,0-2.4-0.4-3.2-1.3c-0.6-1-0.8-2.1-0.6-3.4l25.9-122c0.2-1.4,0.9-2.5,2.1-3.4  c1.1-0.9,2.3-1.3,3.6-1.3H337c13.9,0,25,2.9,33.4,8.6c8.5,5.8,12.8,14.1,12.8,25c0,3.1-0.4,6.4-1.1,9.8c-3.1,14.4-9.4,25-19,31.9  c-9.4,6.9-22.3,10.3-38.7,10.3h-25.3l-8.6,41.1c-0.3,1.4-0.9,2.5-2.1,3.4c-1.1,0.9-2.3,1.3-3.6,1.3H259.3z M325.7,242.9  c5.3,0,9.8-1.4,13.7-4.3c4-2.9,6.6-7,7.9-12.4c0.4-2.1,0.6-4,0.6-5.6c0-3.6-1.1-6.4-3.2-8.3c-2.1-2-5.8-3-10.9-3h-22.5l-7.1,33.6  H325.7z"/> </svg>
                                    </a>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div style="display:flex; justify-content:space-between; margin-top:15px;margin-bottom: 6px;">
                        <div>
                        ` + fflOnFileBadge + ` ` + sotOnFileBadge + ` ` + knowSOTBadge + ` 
                        </div>
                        <div class="dealer-checkbox-wrapper">
                            <input type="checkbox" class="dealer-checkbox">
                        </div>
                    </div>
                </div>
            </div>
            
            
        </div>`);

        $('#ffl-checkout-by-ttg-dealer-list').append(dealerDiv);

        let fflIcon = L.icon({
            iconUrl:        FFLCheckoutByTTG_CheckoutSettings.plugin_url +  getVerifiedIcon(ffl),
            shadowUrl:      FFLCheckoutByTTG_CheckoutSettings.plugin_url + 'public/css/images/marker-shadow.png',
            iconSize:       [25,41],
            iconAnchor:     [12,41],
            popupAnchor:    [1,-34],
            tooltipAnchor:  [16,-28],
            shadowSize:     [41,41]
        });

        let fflVerifiedMessage  = getVerifiedMessage(ffl);
        let popupInfo           = 
        `<strong style="font-size: 14px;">
            ` + ffl.prefered_name + `
        </strong>
        ${ffl.rating || ffl.reviews ? `

            <div style="display: flex;">
                <svg width="15" height="15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.38694 14.4778C3.02507 14.6634 2.61444 14.3381 2.68757 13.9228L3.46569 9.48843L0.162878 6.34218C-0.145559 6.04781 0.0147532 5.50968 0.428191 5.45156L5.02007 4.79906L7.06757 0.742496C7.25225 0.376871 7.75194 0.376871 7.93663 0.742496L9.98413 4.79906L14.576 5.45156C14.9894 5.50968 15.1498 6.04781 14.8404 6.34218L11.5385 9.48843L12.3166 13.9228C12.3898 14.3381 11.9791 14.6634 11.6173 14.4778L7.50069 12.3628L3.38694 14.4778Z" fill="#ffbf13"></path></svg>
                ${ffl.rating ? `<b style="margin-left:3px;">` + ffl.rating + `</b>` : ``} ${ffl.reviews ? `<span style="margin-left:3px;">(` + ffl.reviews + ` reviews)</span>` : ``}
            </div>
            ` : `
            <div style="display: flex;">
                <svg width="15" height="15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.38694 14.4778C3.02507 14.6634 2.61444 14.3381 2.68757 13.9228L3.46569 9.48843L0.162878 6.34218C-0.145559 6.04781 0.0147532 5.50968 0.428191 5.45156L5.02007 4.79906L7.06757 0.742496C7.25225 0.376871 7.75194 0.376871 7.93663 0.742496L9.98413 4.79906L14.576 5.45156C14.9894 5.50968 15.1498 6.04781 14.8404 6.34218L11.5385 9.48843L12.3166 13.9228C12.3898 14.3381 11.9791 14.6634 11.6173 14.4778L7.50069 12.3628L3.38694 14.4778Z" fill="#ffbf13"></path></svg>
                <span style="margin-left:3px;">No ratings</span>
            </div>`
        }<br>
        <b>FFL:</b> ` + ffl.formatted_license_number + `<br> 
        ${ffl.primary_business_type ? `<b>Type: </b>` + ffl.primary_business_type + `<br>` : ``}
        <b>Phone:</b> ` + ffl.phone_number 
        + fflVerifiedMessage;

        let marker              = {marker: L.marker([ffl.premises_latitude, ffl.premises_longitude], {icon: fflIcon, zIndexOffset: getVerifiedZIndex(ffl)}).addTo(map).bindPopup(popupInfo), ffl: ffl.license_number};
            
        markers.push(marker);
        bounds.push([ffl.premises_latitude, ffl.premises_longitude]);

        marker.marker.on('click', function(e) {

            $('.dealer-checkbox').prop('checked', false);

            selectFFLDealder(ffl)

            let correspondingDiv = $('.dealer[data-ffl="' + ffl.license_number + '"]');

            $('.dealer').removeClass('active');
            $('.dealer-checkbox').prop('checked', false);
            $(correspondingDiv).addClass('active');
            $(correspondingDiv).find('.dealer-checkbox').prop('checked', true);
            correspondingDiv[0].scrollIntoView({ behavior: 'smooth', block: 'center' });

            map.flyTo([ffl.premises_latitude, ffl.premises_longitude], 16, { animate: true, duration: 1.5, easeLinearity: 0.25 });
            marker.marker.openPopup();
        });

        dealerDiv.click(function() {

            selectFFLDealder(ffl)

            $('.dealer').removeClass('active');
            $('.dealer-checkbox').prop('checked', false);
            $(this).addClass('active');
            $(this).find('.dealer-checkbox').prop('checked', true);

            map.flyTo([ffl.premises_latitude, ffl.premises_longitude], 16, { animate: true, duration: 1.5, easeLinearity: 0.25 });
            marker.marker.openPopup();
        });
    }

    function selectFFLDealder(ffl) {

        let sotOptionInput = document.getElementById('ffl-checkout-by-ttg-for-woocommerce-input-shipping_ffl_ttg_option_sot');

        connector.changeShippingValues(ffl.premises_address, "", ffl.premises_city, ffl.premises_state, ffl.premises_zip_code);
        
        if (connector.isSOTUploadEnabled() && !ffl.sot_on_file) {
            connector.changeValue(sotOptionInput, '');
            connector.showSOTUploadOptions();
        } else {

            connector.hideSOTUploadOptions();
            connector.changeValue(sotOptionInput, 'sot_on_file');
        }
        
        $("input[name='shipping_ffl_ttg_chosen_ffl']").val(ffl.license_number);
        $("input[name='shipping_ffl_ttg_chosen_ffl_expiration']").val(ffl.expiration);

        // Block version
        let fflNumberInput = document.getElementById('ffl-checkout-by-ttg-for-woocommerce-input-shipping_ffl_ttg_chosen_ffl');
        connector.changeValue(fflNumberInput, ffl.license_number);

        let fflExpirationInput = document.getElementById('ffl-checkout-by-ttg-for-woocommerce-input-shipping_ffl_ttg_chosen_ffl_expiration');
        connector.changeValue(fflExpirationInput, ffl.expiration)
    }

    function getVerifiedIcon(ffl) {

        if (!ffl.ffl_on_file) {
            return 'public/css/images/ffl-unverified-icon.png';
        }

        return 'public/css/images/ffl-verified-icon.png';
    }

    function getVerifiedZIndex(ffl) {

        if (!ffl.ffl_on_file) {
            return 1;
        }

        return 3;
    }

    function getVerifiedMessage(ffl) {

        if (!ffl.ffl_on_file) {
            return `<br><br><svg width="8px" height="8px" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 122.88 122.88" style="margin-right:4px" xml:space="preserve"><style type="text/css">.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#cb6060;}</style><g><path class="st0" d="M61.44,0c33.93,0,61.44,27.51,61.44,61.44c0,33.93-27.51,61.44-61.44,61.44C27.51,122.88,0,95.37,0,61.44 C0,27.51,27.51,0,61.44,0L61.44,0z"/></g></svg><b>Dealer Contact Required for Transfer Details</b>. We need a signed copy of their FFL.`;
        }

        return `<br><br><svg width="8px" height="8px" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 122.88 122.88" style="margin-right:4px" xml:space="preserve"><style type="text/css">.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#6BBE66;}</style><g><path class="st0" d="M61.44,0c33.93,0,61.44,27.51,61.44,61.44c0,33.93-27.51,61.44-61.44,61.44C27.51,122.88,0,95.37,0,61.44 C0,27.51,27.51,0,61.44,0L61.44,0z"/></g></svg ><b>Preferred Dealer</b>: We have this FFL on file`;
    }

    function animateLoading(selector) {
            
        let dotCount = 0;
        let maxDots = 3;
        let interval = setInterval(function() {
            dotCount = (dotCount + 1) % (maxDots + 1);
            let dots = '.'.repeat(dotCount); 
            $(selector).text('Loading' + dots);
        }, 200);

        setTimeout(function() {
            clearInterval(interval);
            $('#ffl-checkout-by-ttg-search-button').text('Find an FFL');
        }, 10000);

        return interval;
    }

    function formatPhoneNumber(number) {

        let areaCode = number.substring(0, 3);
        let centralOfficeCode = number.substring(3, 6);
        let lineNumber = number.substring(6);
        
        return `(${areaCode}) ${centralOfficeCode}-${lineNumber}`;
 
    }
}

function resetMap() {

    if (map == null) {
        return;
    }

    $('#ffl-checkout-by-ttg-dealer-list').slideUp();
    $('.ffl-checkout-by-ttg-dealer-list-search').val("");
    $('.ffl-checkout-by-ttg-dealer-list-search').hide();
    $("#ffl-checkout-by-ttg-zip-code-input").val("");
    map.setView(initialCordinates, initialZoomLevel); 

    connector.changeShippingValues("", "", "", "", "");
    connector.hideSOTUploadOptions();

    $('#ffl-checkout-by-ttg-dealer-list').empty();
    markers.forEach(function(marker) {
        map.removeLayer(marker.marker);
    });

    markers = []; 
    
    $("input[name='shipping_ffl_ttg_chosen_ffl']").val("");
    $("input[name='shipping_ffl_ttg_chosen_ffl_expiration']").val("");

    // Block version
    let fflNumberInput = document.getElementById('ffl-checkout-by-ttg-for-woocommerce-input-shipping_ffl_ttg_chosen_ffl');
    connector.changeValue(fflNumberInput, "");

    let fflExpirationInput = document.getElementById('ffl-checkout-by-ttg-for-woocommerce-input-shipping_ffl_ttg_chosen_ffl_expiration');
    connector.changeValue(fflExpirationInput, "")
}

export { init, resetMap }